module.exports = __webpack_public_path__ + "img/9788960513228.83eb05ef.jpg";